// extracted by mini-css-extract-plugin
module.exports = {"FaqAskQuestion":"ox_a bhs_px bhs_a bhs_w","FaqAskQuestion__outdated":"ox_b bhs_ul bhs_vz"};